import { Button } from '@mui/material'
import { Checkmark16Regular } from '@/components/Icon'

export default function ContextConnectedButton({ children = 'Connected' }) {
  return (
    <Button
      variant="contextConnected"
      disableElevation
      disableRipple
      tabIndex={-1}
      startIcon={<Checkmark16Regular fontSize={18} />}
    >
      {children}
    </Button>
  )
}
